import { Navigate, useLocation } from 'react-router-dom'
import { isTokenExpired } from 'utils/isTokenExpired'
import { getTokenFromCookies, resetTokenFromCookies } from 'utils/tokenFromCookies'

type PrivateRouteProps = {
  element: React.ReactElement
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ element }: PrivateRouteProps) => {
  const location = useLocation()
  const token = getTokenFromCookies()

  try {
    if (!token || isTokenExpired(token)) {
      console.error(!token ? 'Token is missing in Cookies' : 'Token is expired')
      resetTokenFromCookies()
      return <Navigate to="/" state={{ from: location }} replace />
    }

    // Se o token for válido, retorna o elemento da rota privada
    return element
  } catch (parseError) {
    console.error('Error parsing token:', parseError)
    resetTokenFromCookies()
    return <Navigate to="/" state={{ from: location }} replace />
  }
}

export default PrivateRoute
